import {
  FormLabel,
  SortSelect,
  TextV2,
} from '@insights-ltd/design-library/components';
import { Box } from '@mui/material';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import {
  SearchLabelContainer,
  FieldLabel,
} from './SearchFilterStyledComponents';
import { SelectTypes, SearchFieldLabelProps } from '../SearchFilter.types';

type Options = {
  label: string;
  value: string;
};

export const getFormLabel = <T extends SelectTypes['labelSelectOptionsType']>({
  showLabelDropdown,
  value,
  onChange,
  labelText,
  options,
}: SearchFieldLabelProps<T>) => {
  if (showLabelDropdown && !!value) {
    return (
      <Box
        sx={{
          mt: 0,
          padding: 0,
          alignContent: 'center',
          justifyContent: 'center',
          '& > div > div': {
            padding: 0,
          },
          '& > div > p': {
            position: 'relative',
            marginRight: spacingSizeMap.XS,
            marginTop: 0,
            marginBottom: 0,
          },
          '& > div > div > input': {
            height: '1px',
          },
        }}
      >
        <SortSelect
          value={value as string}
          onChange={(event: { target: { value: string } }) =>
            onChange && onChange(event.target.value as T)
          }
          labelText={labelText}
          sortOptions={(options as Options[]) ?? []}
        />
      </Box>
    );
  } else {
    return (
      <FormLabel
        sx={{ alignSelf: 'center' }}
        label={
          <SearchLabelContainer>
            <FieldLabel
              sx={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}
            >
              <TextV2 component="p" variant="bodyBold">
                {labelText}
              </TextV2>
            </FieldLabel>
          </SearchLabelContainer>
        }
        htmlFor="search-filter-input"
      />
    );
  }
};
